import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-gray-50">
      <Card className="mx-4 w-full max-w-md">
        <CardContent className="pt-6">
          <div className="mb-4 flex gap-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="font-bold text-2xl text-gray-900">404 Page Not Found</h1>
          </div>

          <p className="mt-4 text-gray-600 text-sm">Did you forget to add the page to the router?</p>
        </CardContent>
      </Card>
    </div>
  );
}
